<template>
  <div>
    <label
      for="last_name"
      class="form-label placeholder-label relative w-full mt-3 text-base"
    >
      <input
        id="last_name"
        v-model="validate.last_name.$model"
        type="text"
        class="form-control p-3"
        :class="{ 'border-theme-6': validate.last_name.$error }"
        placeholder=" "
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <span
        class="p-3 absolute opacity-50 left-0 top-0 transition-all duration-300 ease-in-out text-base"
        >Last Name</span
      >
    </label>
    <div
      v-for="error of validate.last_name.$errors"
      :key="error.$uid"
      class="input-errors"
    >
      <div class="error-msg text-theme-6 mt-2">
        {{ error.$message }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { required, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default defineComponent({
  props: {
    lastName: {
      type: String,
      default: () => {
        return "";
      },
      required: false
    },
    touch: {
      type: Boolean,
      required: false
    }
  },
  setup: () => ({ validate: useVuelidate() }),
  data() {
    return {
      last_name: this.lastName
    };
  },
  watch: {
    touch: function(val) {
      if (val) {
        this.validate.last_name.$touch();
      }
    }
  },
  validations() {
    return {
      last_name: { required, minLength: minLength(2) }
    };
  }
});
</script>
